export enum AipFilterCriteria {
    IS_NULL = "IS_NULL",
    IS_NOT_NULL = "IS_NOT_NULL", 
    CONTAINS = "CONTAINS",
    DOES_NOT_CONTAIN = "DOES_NOT_CONTAIN", 
    EQUALS = "EQUALS", 
    BETWEEN = "BETWEEN"
}